import { i18n } from '@/plugins/i18n';
import { senseiModal } from '@/utils/ai';
import HTMLString from '@/utils/classes/HTMLString';

function IATeacher() {}
IATeacher.init = function(nextLesson) {
  var btns = [{ title: i18n.t("message.DONE") }]
  if (nextLesson) {
    btns.push({ title: i18n.t("message.NEXT_LESSON"), action: nextLesson() });
  }
  return btns;
}
/**
 * Initialize a Neo lesson screen with a modal occupying mmost of the screen
 * @param  {String} lessonName - key used in translations
 * @param  {Function} nextLesson - call to IATeacher.lesson to add a 'next lesson' button
 */
IATeacher.lesson = (lessonName, nextLesson) => {
  senseiModal(
    i18n.t("sensei." + lessonName + "_TITLE"),
    i18n.t("sensei." + lessonName),
    IATeacher.init(nextLesson), {right: "20px"},
  );
}

export default IATeacher;
